
@switch (loginStatus) {
  @case (loginStatuses.AccountDisabled) {
    <h3 class="my-4 heading text-center">Account Disabled</h3>
    <div class="row">
      <div class="col-lg-4 offset-lg-4">
        <p>This account is disabled. Please call our support team: <b>1-781-214-3424</b>.</p>
      </div>
    </div>
  }
  @case (loginStatuses.AccountLocked) {
    <h3 class="my-4 heading text-center">Account Locked</h3>
    <div class="row">
      <div class="col-lg-4 offset-lg-4">
        You have entered an incorrect password too many times. To unlock your account, please call our support team:
        <b>1-781-214-3424</b>.
      </div>
    </div>
  }
  @case (loginStatuses.InvitationNotAccepted) {
    <h3 class="my-4 heading text-center">Account Not Active</h3>
    <div class="row">
      <div class="col-lg-4 offset-lg-4">
        <p>This account is not active. Please check your email for an invitation email to get started.</p>
        <p>If you need further assistance, please call our support team: <b>1-781-214-3424</b>.</p>
      </div>
    </div>
  }
  @default {
    <h3 class="my-4 heading text-center">Sign in to NuvemRX 340B Recovery</h3>
    <div class="row">
      <div class="col-lg-4 offset-lg-4">
        @if (logoutReasons.inactivity === logoutReason) {
          <div class="alert alert-info text-center">
            For your security, NuvemRX logs you out after 20 minutes. Please sign in below to continue.
          </div>
        }
        <form (ngSubmit)="onSubmit(loginForm)" #loginForm="ngForm">
          <div class="mb-3">
            <label for="email">Email address</label>
            <input
              id="email"
              name="email"
              class="form-control"
              type="email"
              [(ngModel)]="userCredentials.email"
              [ngClass]="invalidCss('email', loginForm)"
              [disabled]="emailSubmitted"
              required
              placeholder="Email"
              />
            <div class="invalid-feedback">Email address is required.</div>
          </div>
          @if (emailSubmitted) {
            <div class="mb-3">
              <label for="password">Password</label>
              <input
                id="password"
                name="password"
                class="form-control"
                type="password"
                [(ngModel)]="userCredentials.password"
                [ngClass]="invalidCss('password', loginForm)"
                required
                placeholder="Password"
                autocomplete="password"
                />
              <div class="invalid-feedback">Password is required.</div>
            </div>
          }
          <button [disabled]="submitting" type="submit" class="btn w-100">Sign in</button>
          @if (loginStatus === loginStatuses.InvalidCredentials) {
            <p class="text-danger my-2">
              Invalid email or password. Please try again or contact support if the issue persists.
            </p>
          }
          @if (loginStatus === loginStatuses.UnexpectedFailure) {
            <p class="text-danger my-2">
              An unexpected error has occurred. Please try again or contact support if the issue persists.
            </p>
          }
          @if (loginStatus === loginStatuses.DeviceNotAuthorized) {
            <p class="text-danger my-2">
              Failed to authorize device. Please try again or contact support if the issue persists.
            </p>
          }
        </form>
        <p class="mt-3 text-center">
          Trouble signing in? <br /><a href="/forgot-password">Reset your password</a> or Call us at
          <a href="tel:1-781-214-3424">1-781-214-3424</a>.
        </p>
      </div>
    </div>
  }
}
